import ApiClient, { parseRequestData } from "../utilities/http";
import { TrackTraceFilters } from "./types";

const query = (params: Record<string, any> = {}) => {
    const clean = Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''));
    const qs = parseRequestData(clean, 'get');
    return qs ? `?${qs}` : '';
};

export const getTrackTraceLocations = async (params: Pick<TrackTraceFilters, 'q' | 'asset_type_id'> = {}) => {
    const response = await ApiClient.get(`track-trace/locations${query(params)}`);
    return response.data.locations || [];
};

export const getTrackTraceLocationMap = async (locationId: string, filters: TrackTraceFilters = {}) => {
    const response = await ApiClient.get(`track-trace/locations/${locationId}/map${query(filters)}`);
    return response.data;
};

export const searchTrackTraceAssets = async (params: TrackTraceFilters & { location_id?: string }) => {
    const response = await ApiClient.get(`track-trace/assets/search${query(params)}`);
    return response.data.assets || [];
};

export const getFavoriteTrackTraceLocations = async () => {
    const response = await ApiClient.get('track-trace/favorite-locations');
    return response.data;
};

export const updateFavoriteTrackTraceLocations = async (locationIds: string[]) => {
    const response = await ApiClient.put('track-trace/favorite-locations', { location_ids: locationIds });
    return response.data;
};
